// ------------------------------------------
// Application configuration
// ------------------------------------------
// jquery migratoin fix from 2 to 3
const $ = require('jquery');
$.fn.load = function (callback) {
    var el = $(this);

    el.on('load', callback);

    return el;
};

require('angular');
//Modules
require('../wowcommon/wowcommon.js');

//Aplication declaration.
angular.module('wowApp.shop',
    ['wowApp.common', 'ui.router', 'ngAnimate', 'ngMessages', 'restangular', 'performance', 'oc.lazyLoad', 'ngSanitize', 'ngAria', 'slickCarousel', 'ui.bootstrap']);

angular.module('wowApp.shop').constant('jQuery', require('jquery'));

require('./configuration');


// ------------------------------------------
// Components
// ------------------------------------------
require('./components/config');
require('./components/pagemetadata');
require('./components/loadingindicator');
require('./components/shopper');
require('./components/categories');
require('./components/shelfproduct');
require('./components/trolley');
require('./components/collectionzone');
require('./components/delivery');
require('./components/globalheader');
require('./components/accessiblity');
require('./components/productgroup');
require('./components/dynamiccontent');
require('./components/address');
require('./components/openclosepanels');
require('./components/misseddelivery');
require('./components/rescheduledelivery');
require('./components/pickupconfirmation');
require('./components/rescheduleconfirmation');
require('./components/shoppagestate');
require('./components/savedcard');
require('./components/login');
require('./components/login/persistent-login');
require('./components/signup');
require('./components/smallformatmenu');
require('./components/specials');
require('./components/resetpassword');
require('./components/cards');
require('./components/search');
require('./components/inspiration');
require('./components/footer');
require('./components/shoplocator');
require('./components/copyright');
require('./components/productgroups');
require('./components/dialog');
require('./components/unsubscribeedm');
require('./components/accessiblity/primaryHeader');
require('./components/socialmedia');
require('./components/badges');
require('./components/notification');
require('./components/filters');
require('./components/return-to-top');
require('./components/infinate-scroll');
require('./components/customer-reviews');
require('./components/star-rating');
require('./components/toggle');
require('./components/toolbar');
require('./components/storepicker');
require('./components/contentoverlay');
require('./components/button-state-icon');
require('./components/animation-events');
require('./components/richer-relevance');
require('./components/order-tracker');
require('./components/catalog');
require('./components/help');
require('./components/competitions');
require('./components/collection-time-switch');
require('./components/feature-promo');
require('./components/bwsbot');
require('./components/googlecaptcha');
require('./components/selfexclusion');
require('./components/id-verification');
require('./components/password-validation');
require('./components/secure-user-account');
require('./components/explore-categories');
require('./components/receipt-rewards');
require('./components/sdd-dialog');
require('./components/help-center');
require('./components/aem');


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/shop.module.js
 **/